(() => {
  const initStickyButton = () => {
    const buttonSticky = document.querySelector('.product-form__buttons-sticky');
    const buttonWrapper = document.querySelector('.product-form__buttons');
    const mediaSection = document.getElementById('Section-3');
    const stickyClass = 'is-sticky';
    let placeholder;

    // Create a placeholder for the button to prevent layout shifts
    if (buttonWrapper) {
      placeholder = document.createElement('div');
      placeholder.classList.add('product-form__placeholder');
      placeholder.style.display = 'none'; // Initially hidden
      placeholder.style.width = `${buttonWrapper.offsetWidth}px`;
      placeholder.style.height = `${buttonWrapper.offsetHeight}px`;
      buttonWrapper.parentNode.insertBefore(placeholder, buttonWrapper.nextSibling);
    }

    let buttonIsInViewport = true;
    let mediaSectionIsInViewport = false;

    // Check if both elements exist
    if (buttonSticky && buttonWrapper) {
      // Observer for the button
      const buttonObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          buttonIsInViewport = entry.isIntersecting;
          if (!entry.isIntersecting && !mediaSectionIsInViewport) {
            buttonSticky.classList.add(stickyClass);
            placeholder.style.display = 'block'; // Show placeholder
          } else {
            buttonSticky.classList.remove(stickyClass);
            placeholder.style.display = 'none'; // Hide placeholder
          }
        });
      }, {
        rootMargin: '0px',
        threshold: 0
      });

      buttonObserver.observe(buttonWrapper);

      if (mediaSection) {
        // Observer for the media section
        const mediaSectionObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const rect = mediaSection.getBoundingClientRect();
            const passedMediaSection = rect.top < 0; // Check if we've scrolled past mediaSection
            mediaSectionIsInViewport = entry.isIntersecting || passedMediaSection;
            if (mediaSectionIsInViewport) {
              buttonSticky.classList.remove(stickyClass);
              placeholder.style.display = 'none'; // Hide placeholder
            } else if (!buttonIsInViewport) {
              buttonSticky.classList.add(stickyClass);
              placeholder.style.display = 'block'; // Show placeholder
            }
          });
        }, {
          rootMargin: '0px',
          threshold: 0
        });

        mediaSectionObserver.observe(mediaSection);
      }
    }
  };

  // Use matchMedia to listen for changes
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  const handleMediaChange = (e) => {
    if (e.matches) {
      // If the media query matches (less than 990px)
      initStickyButton();
    } else {
      // Cleanup or disable sticky functionality
      const buttonSticky = document.querySelector('.product-form__buttons-sticky');
      const placeholder = document.querySelector('.product-form__placeholder');
      if (buttonSticky) {
        buttonSticky.classList.remove('is-sticky');
      }
      if (placeholder) {
        placeholder.remove();
      }
    }
  };

  // Initial check
  handleMediaChange(mediaQuery);

  // Listen for changes
  mediaQuery.addEventListener('change', handleMediaChange);
})();